export const outcomeLabels = {
  delivered: 'Delivered', refused: 'Customer refusal', unreceived: 'Not received',
  returned: 'Returned', in_transit: 'In transit', unknown: 'Unknown', revoked: 'Revoked',
};

export function displayRiskTime(value, precision, systemTimezone, sourceTimezone) {
  if (!value || !['day', 'second'].includes(precision) || typeof value !== 'string' || !/(?:Z|[+-]\d{2}:\d{2})$/i.test(value)) return '—';
  const timezone = precision === 'day' ? sourceTimezone : systemTimezone;
  if (!timezone) return '—';
  try {
    const date = new Date(value);
    if (!Number.isFinite(date.getTime())) return '—';
    const options = { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit',
      ...(precision === 'second' ? { hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' } : {}) };
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', options).formatToParts(date).map(part => [part.type, part.value]));
    const dateText = `${parts.year}-${parts.month}-${parts.day}`;
    return precision === 'day' ? `${dateText} (date only, ${timezone})` : `${dateText} ${parts.hour}:${parts.minute}:${parts.second}`;
  } catch { return '—'; }
}

export function responseData(response) {
  if (response?.status !== 200) {
    const fields = response?.data?.errors || response?.errors;
    const details = fields && Object.values(fields).flat().filter(value => typeof value === 'string');
    throw new Error(details?.length ? [...new Set(details)].join(' ') : response?.msg || response?.message || 'The request could not be completed.');
  }
  return response.data;
}

export function requestError(error) {
  if (error?.response?.data) {
    try { responseData(error.response.data); } catch (detail) { return detail.message; }
  }
  return error?.message || 'Unable to reach the server. Please retry.';
}

export function readImportFile(file, format) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Unable to read this file. Select it again.'));
    reader.onabort = () => reject(new Error('File reading was cancelled.'));
    reader.onload = () => resolve(format === 'exchange'
      ? { exchange: String(reader.result) }
      : { file_base64: String(reader.result).split(',')[1] });
    if (format === 'exchange') reader.readAsText(file); else reader.readAsDataURL(file);
  });
}

export function downloadRiskFile(data) {
  if (typeof data?.content !== 'string' || !data.filename) throw new Error('The server did not return a downloadable file.');
  const blob = new Blob([data.content], { type: data.mime_type || 'application/octet-stream' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = data.filename.replace(/[\\/\r\n]/g, '_');
  document.body.appendChild(link);
  try { link.click(); } finally { link.remove(); setTimeout(() => URL.revokeObjectURL(url), 1000); }
}
